module.exports = __webpack_public_path__ + "static/media/Image-4.6636692b.png";